import forEach from '../../../../javascripts/dom/forEach';
import addClass from '../../../../javascripts/dom/addClass';
import removeClass from '../../../../javascripts/dom/removeClass';

const galleries = document.querySelectorAll('[data-js-module="o-gallery"]');
const slidesSelector = '[data-js-element="o-gallery__slides"]';
const controlSelector = '[data-js-element="o-gallery__controls"]';
const inViewportClass = 'o-gallery--is-in-viewport';

const init = async () => {
  const { tns } = await import(
    /* webpackChunkName: "tiny-slider" */ '../../../../../node_modules/tiny-slider/src/tiny-slider'
  );

  forEach(galleries, (index, element) => {
    const slidesContainer = element.querySelector(slidesSelector);
    const slider = tns({
      container: slidesContainer,
      arrowKeys: true,
      mouseDrag: true,
      mode: 'gallery',
      autoHeight: true,
      loop: false,
      nav: false,
      swipeAngle: false,
      controls: false,
      animateIn: 'o-gallery__fade-in',
      animateOut: 'o-gallery__fade-out',
      animateNormal: 'o-gallery__fade-normal',
      onInit(info) {
        if (info.slideCount <= 1) {
          element.classList.add('o-gallery--highlight');
        } else {
          const overallIndex = element.querySelector('.o-gallery__controls-list-counter-overall');
          overallIndex.textContent = info.slideCount;
        }
      }
    });

    const changeCurrent = function() {
      const info = slider.getInfo();
      const currentIndex = element.querySelector('.o-gallery__controls-list-counter-current');
      currentIndex.textContent = info.displayIndex;

      if (info.displayIndex == info.slideCount) {
        element
          .querySelector('.a-svg-sprite--various-arrow-right')
          .parentNode.setAttribute('aria-disabled', true);
      } else if (info.displayIndex == 1) {
        element
          .querySelector('.a-svg-sprite--various-arrow-left')
          .parentNode.setAttribute('aria-disabled', true);
      } else {
        element
          .querySelector('.a-svg-sprite--various-arrow-left')
          .parentNode.removeAttribute('aria-disabled');

        element
          .querySelector('.a-svg-sprite--various-arrow-right')
          .parentNode.removeAttribute('aria-disabled');
      }
    };

    slider.events.on('indexChanged', changeCurrent);

    element.querySelector('.a-svg-sprite--various-arrow-right').onclick = () => {
      slider.goTo('next');
    };

    element.querySelector('.a-svg-sprite--various-arrow-left').onclick = () => {
      slider.goTo('prev');
    };

    new window.Waypoint({
      element,
      handler: direction => {
        if (direction === 'down') {
          addClass(element, inViewportClass);
        } else {
          removeClass(element, inViewportClass);
        }
      },
      offset: () => window.Waypoint.viewportHeight() - 100
    });
  });
};

if (galleries.length) init();
